<template>
    <section class="ui-checklist">
        <h4 class="ui-checklist-title">{{ title }}</h4>
        <ul>
            <li v-for="item in items" class="ui-checklist-checkbox">
                <label class="ui-checklist-checkbox--label">
                    <input type="checkbox" class="ui-checklist-checkbox--box"/>
                    <span class="ui-checklist-checkbox--title">{{ item }}</span>
                </label>
            </li>
        </ul>
    </section>
</template>

<script>
    export default {
        name: 'ui-checklist',
        props: ['title', 'items'],
    }
</script>

<style>

.ui-checklist {
    /*margin-bottom: 15px;*/
    padding:10px 10px 5px 10px;
}

.ui-checklist-checkbox{
    /*margin: 5px 5px 5px 10px;*/
    height:24px;
    display:flex;
    flex-flow:row nowrap;
    align-items:center;
    justify-content: flex-start;
    margin-left:5px;
}

.ui-checklist-checkbox--box{
    margin-right:6px;
}

.ui-checklist-checkbox--title:hover{
    opacity: 0.5;
}
.ui-checklist-checkbox--label {
    font-size: 1em;
    width: 100%;
}

.ui-checklist-checkbox--label:hover{
    cursor: pointer;
}

h4.ui-checklist-title {
    font-size: 0.78em;
    color:rgba(0,0,0,0.5);
    font-weight:600;
}


</style>



// WEBPACK FOOTER //
// UiChecklist.vue?abc468d8